import { IdeaSummaryCard } from './idea-summary-card.tsx'
import React from 'react'
import Row from 'antd/es/grid/row'
import Col from 'antd/es/grid/col'
import Spin from 'antd/es/spin/index'
import IdeyaTypography from '@/common/antd/ideya-typography.tsx'
import { SummaryInfoHelp } from './idea-list-summary-info-help.tsx'
import { SummaryValueText } from './idea-summary-value-text.tsx'
import { STAR_SCORE_MAX } from '@/utils/constants.ts'
import { useTranslation } from 'react-i18next'
import StarFilled from '@assets/icons/idea-list/star-filled.svg'

interface IdeaSummaryStarScoreProps {
  shouldShowSelectContributorMsg: boolean
  isLoading?: boolean
  score: string
  previousScore: string
}

export const IdeaSummaryStarScore: React.FC<IdeaSummaryStarScoreProps> = ({
  shouldShowSelectContributorMsg,
  isLoading,
  score,
  previousScore,
}) => {
  const { t } = useTranslation()
  const isNotAllowedNum = score === '' || Number.isNaN(Number(score))
  const overlayComponent = shouldShowSelectContributorMsg ? (
    <SummaryInfoHelp />
  ) : isLoading ? (
    <Spin />
  ) : null

  return (
    <IdeaSummaryCard
      title={'Star Score'}
      overlayMsg={overlayComponent}
      textComponent={
        <Row gutter={[10, 0]} align={'bottom'} style={{ height: '100%' }}>
          <Col>
            <SummaryValueText
              value={score}
              suffix={isNotAllowedNum ? '' : `/${STAR_SCORE_MAX}`}
            />
          </Col>
          <Col>
            <StarFilled />
          </Col>
        </Row>
      }
      rows={[
        {
          label: t('idea_list.summary_info.previous_score'),
          value: previousScore,
        },
      ]}
    >
      {isNotAllowedNum && (
        <IdeyaTypography.Text type={'secondary'} size={'sm'}>
          {t('idea_list.summary_info.no_data_to_show')}
        </IdeyaTypography.Text>
      )}
    </IdeaSummaryCard>
  )
}
